<template>
    <div class="energy-analysis">
        <el-row>
            <el-col :span="8">
                <p>所有车辆</p>
                <el-button type="primary" @click="changeOption()">主要按钮</el-button>
                <el-button type="primary" @click="changeOption3()">主要按钮</el-button>
            </el-col>
            <el-col :span="16" class="map"><v-chart v-bind:option="option" idChart="testChart"></v-chart></el-col>
        </el-row>
    </div>
</template>

<script>
import chart from '../plugins/chart';
export default {
    name: 'energy-analysis',
    created () {
        this.option = {
            title: {
                text: 'ECharts 入门示例'
            },
            tooltip: {},
            legend: {
                data: ['销量']
            },
            xAxis: {
                data: ['衬衫', '羊毛衫', '雪纺衫', '裤子', '高跟鞋', '袜子']
            },
            yAxis: {},
            series: [{
                name: '销量',
                type: 'bar',
                data: [5, 20, 36, 10, 10, 20]
            }]
        };
    },
    data () {
        return {
            menus: [],
            option: {}
        };
    },
    components: {
        'v-chart': chart
    },
    methods: {
        changeOption () {
            this.option.series[0].data = [4, 3, 5, 5, 6, 5];
        },
        changeOption3 () {
            this.option.series[0].data = [1, 3, 4, 5, 6, 7];
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.map{
    height: 800px;
}
</style>




// WEBPACK FOOTER //
// energy-analysis.vue?7ffa8614